import { Injectable } from '@angular/core';

@Injectable()
export class CheckAndUncheckService {

  arrayRemove(value, array): number[] {
    return array.filter(n => n !== value);
  }

  checkAndUncheck(segment, array, i) {
    if (segment.isChecked) {
      array = this.arrayRemove(i, array);
      segment.isChecked = false;
    } else {
      array.push(i);
      segment.isChecked = true;
    }
    return array;
  }

  constructor() {}
}
